import type { SorterResult } from 'antd/es/table/interface';
import { DefaultOptionType } from 'antd/lib/select';
import { OutgoingCallsTablet } from '../../../models/OutgoingCalls/OutgoingCalls';

export enum ResultsTypes {
  Unknown = 'Unknown',
  NotIdentified = 'NotIdentified',
  Confirmed = 'Confirmed',
  Declined = 'Declined',
  Rescheduled = 'Rescheduled',
  ClinicCancelled = 'ClinicCancelled',
  ClinicRescheduled = 'ClinicRescheduled',
  InvalidNumber = 'InvalidNumber',
  NeedOperator = 'NeedOperator',
}

export interface SortedActive {
  date: null | string;
  surname: null | string;
  phone: null | string;
  clinic: null | string;
  surnameDoctor: null | string;
  status: null | string;
}

declare type EventValue<DateType> = DateType | null;
export declare type RangeValue<DateType> =
  | [EventValue<DateType>, EventValue<DateType>]
  | null;

export interface AudioSrc {
  [key: string]: string;
}

export type TableSorter<RecordType extends object = OutgoingCallsTablet> =
  | SorterResult<RecordType>
  | SorterResult<RecordType>[];

export type FilterOptionType = (
  input: string,
  option?: DefaultOptionType,
) => boolean;
